import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VisitRoleAdminComponent } from './component/visit-role-admin/visit-role-admin.component';

import { CommonLayoutModule, CommonUIModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@sdbn/appclient';
import { DictionaryModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { VisitRoleTaskDialogComponent } from './component/visit-role-task-dialog/visit-role-task-dialog.component';



@NgModule({
  declarations: [
    VisitRoleAdminComponent,
    VisitRoleTaskDialogComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    DictionaryModule,
    CommonTranslationModule,
    CommonUIModule
  ],
  exports: [
    VisitRoleAdminComponent
  ]
})
export class VisitRolesModule { }
